"use client";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { setDocumentCookie } from "./cookie-utils";

export default function SetCampaignid() {
  const searchParams = useSearchParams();
  useEffect(() => {
    const campaign = searchParams.get("campaign");
    if (campaign) {
      setDocumentCookie({ name: "campaign_id", value: campaign, options: { maxAge: 30 * 24 * 60 * 60 }  });
    }
  }, []);
  return null;
}
